import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
// 全局样式
import "@/assets/css/config.scss";
import "@/assets/css/common.scss";
import "swiper/css/swiper.min.css";


Vue.config.productionTip = false;
// Vue.prototype.$apiYf = process.env.NODE_ENV === 'development' ? 'yfapi' : 'https://hisantech.com/';
Vue.prototype.$apiYf = "https://hisantech.com/";

router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
